import { ReactNode } from 'react';

import { UserInfo } from '@cartwhl/common/types';
import { hexColorToBrightness } from '@cartwhl/common/utils/hexColorToBrightness';
import { stringToColor } from '@cartwhl/common/utils/stringToColor';

import Loading from './Loading';

export default function Avatar({
  size = 7,
  className,
  userInfo,
  children,
}: {
  size?: number;
  className?: string;
  userInfo?: UserInfo;
  children?: ReactNode;
}) {
  const initial =
    userInfo &&
    (userInfo.preferredName.charAt(0) ||
      userInfo.firstName.charAt(0) ||
      userInfo.lastName.charAt(0) ||
      userInfo.email.charAt(0));

  const background =
    (userInfo?.email && stringToColor(userInfo.email)) || '#E7E7E7';
  const bright = hexColorToBrightness(background);
  const isLight = (Math.pow(2 * bright - 1, 3) + 1) / 2 > 0.5;
  const color = isLight ? 'black' : 'white';

  return (
    <div
      className={`outline-hidden flex items-center justify-center rounded-full transition-colors ${
        typeof className === 'string' ? className : ''
      }`}
      style={{ background, width: `${size / 4}rem`, height: `${size / 4}rem` }}
    >
      <span
        className={`font-display font-bold`}
        style={{ color, fontSize: `${size * 2}px`, lineHeight: `100%` }}
      >
        {userInfo && initial}
        {!userInfo && <Loading />}
      </span>
      {children}
    </div>
  );
}
